export const OC_DATES = [
  { label: "Tue 15/09/2026, 10am–1pm", at: "2026-09-15T09:00:00Z" },
  { label: "Tue 13/10/2026, 10am–1pm", at: "2026-10-13T09:00:00Z" },
  { label: "Tue 10/11/2026, 10am–1pm", at: "2026-11-10T10:00:00Z" },
  { label: "Tue 08/12/2026, 10am–12pm", at: "2026-12-08T10:00:00Z" },
  { label: "Tue 12/01/2027, 10am–1pm", at: "2027-01-12T10:00:00Z" },
  { label: "Tue 09/02/2027, 10am–1pm", at: "2027-02-09T10:00:00Z" },
  { label: "Mon 22/03/2027, 2pm–4pm", at: "2027-03-22T14:00:00Z" },
  { label: "Mon 26/04/2027, 2pm–4pm", at: "2027-04-26T13:00:00Z" },
  { label: "Tue 11/05/2027, 10am–1pm", at: "2027-05-11T09:00:00Z" },
  { label: "Tue 08/06/2027, 10am–1pm", at: "2027-06-08T09:00:00Z" },
  { label: "Tue 13/07/2027, 10am–1pm", at: "2027-07-13T09:00:00Z" },
  { label: "Tue 10/08/2027, 10am–1pm", at: "2027-08-10T09:00:00Z" },
  { label: "Tue 14/09/2027, 10am–1pm", at: "2027-09-14T09:00:00Z" },
  { label: "Tue 12/10/2027, 10am–1pm", at: "2027-10-12T09:00:00Z" },
  { label: "Tue 09/11/2027, 10am–1pm", at: "2027-11-09T10:00:00Z" },
  { label: "Tue 14/12/2027, 10am–1pm", at: "2027-12-14T10:00:00Z" },
];

export const upcomingDates = (now = new Date()) => OC_DATES.filter((d) => new Date(d.at) > now);
